import { FormIPSubnetField } from '@ipfabric/ui-components/FormIPSubnetField/FormIPSubnetField';
import type {
  IPSubnetInputValue,
  IPSubnetInputValueOrDraft,
} from '@ipfabric/ui-components/IPSubnetInput/IPSubnetInput.types';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';
import { ipCidrListSchemaZ } from '../../utils/validation';

export const ipScopeExclude: FormSnippet<
  DiscoverySettingsObject,
  { ipScopeExclude: IPSubnetInputValueOrDraft },
  { ipScopeExclude: IPSubnetInputValue }
> = {
  render: ({ form }) => (
    <FormIPSubnetField
      control={form.control}
      name='ipScopeExclude'
      label='Exclude from discovery'
      description='Automatically excluded: 0.0.0.0/8, 172.0.0.0/8, 224.0.0.0/4 and 240.0.0.0/4'
      type='cidr'
    />
  ),
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.ipScopeExclude = {
      ips: model.networks?.exclude ?? [],
    };
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.networks = {
      ...modelDraft.networks,
      exclude: transformedValues.ipScopeExclude.ips,
    };
  },
  schema: z.object({
    ipScopeExclude: ipCidrListSchemaZ,
  }),
};
